const mutations = {
	setNovasExperiencias: (state, novasExperiencias) => {
		state.novasExperiencias = novasExperiencias;
	},

	setMinhasExperiencias: (state, minhasExperiencias) => {
		state.minhasExperiencias = minhasExperiencias;
	},

	setEncontrosComEspecialista: (state, encontrosComEspecialista) => {
		state.encontrosComEspecialista = encontrosComEspecialista;
	},

	loading: (state, loading) => {
		state.isLoading = loading;
	},

	setInteresseAlto(state, { id, confirmado = false }) {
		state.interesseAlto.id = id;

		state.interesseAlto.confirmado = confirmado;
	},

	setInteresseMuitoAlto(state, { id, confirmado = false }) {
		state.interesseMuitoAlto.id = id;

		state.interesseMuitoAlto.confirmado = confirmado;
	},

	setVisualizouModalExperiencias(state, visualizou) {
		state.visualizouModalExperiencias = visualizou;
	},

	setCodigoIes(state, codigo_ies) {
		state.codigo_ies = codigo_ies;
	},

	setCargaHoraria(state, { total, cursada }) {
		state.cargaHorariaTotal = total;

		state.cargaHorariaCursada = cursada;
	},

	checkDatasConflitantes(state) {
		
		let horarios = [];

		for (let i = 0; i < state.minhasExperiencias.length; i++) {
			if (state.minhasExperiencias[i].horarios !== null && state.minhasExperiencias[i].horarios !== undefined) {
				for (let j = 0; j < state.minhasExperiencias[i].horarios.length; j++) {
					// verifica se horario é no futuro
					let dataInicio = new Date(state.minhasExperiencias[i].horarios[j].data_inicio);
					let agora = new Date();
					if (dataInicio >= agora) {
						horarios.push(state.minhasExperiencias[i].horarios[j]);
					}
				}
			}
		}

		for (let i = 0; i < state.novasExperiencias.length; i++) {

			if (state.novasExperiencias[i].horarios !== null) {
				for (let j = 0; j < state.novasExperiencias[i].horarios.length; j++) {
					for (let k = 0; k < horarios.length; k++) {

						let dataInicio = new Date(state.novasExperiencias[i].horarios[j].data_inicio);
						let dataTermino = new Date(state.novasExperiencias[i].horarios[j].data_termino);
						let horarioInicio = new Date(horarios[k].data_inicio);

						if( dataInicio.getTime() <= horarioInicio.getTime() &&
							dataTermino.getTime() >= horarioInicio.getTime()) {
							state.novasExperiencias[i].horarioDisponivel = false;
							break;
						}
					}
				}
			}

			if (state.novasExperiencias[i].horarioDisponivel === undefined) {
				state.novasExperiencias[i].horarioDisponivel = true;
			}


		}

	}


};

export default mutations;
